export default {
  getFavourite: (state) => state.favourite,
};
